// extracted by mini-css-extract-plugin
module.exports = {"icon":"AlertIcon_icon__JUpA1","icon-wrapper":"AlertIcon_icon-wrapper__Ke3wS"};